import { useState } from 'react';
import { Container } from '@mui/material';
import '../../css/GlobalStyles.css';

import Page from '../../components/Page';
import DashboardNavbar from '../../layouts/dashboard/DashboardNavbar';
import DashboardSidebar from '../../layouts/dashboard/DashboardSidebar';

import TicketManagementCardContent from '../components/TicketManagementCardContent';

export default function TicketManagement() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <Page title="Ticket Management">
      <DashboardNavbar onOpenSidebar={() => setSidebarOpen(true)} />
      <DashboardSidebar
        isOpenSidebar={sidebarOpen}
        onCloseSidebar={() => setSidebarOpen(false)}
      />

      <Container maxWidth="false">
        <TicketManagementCardContent />
      </Container>
    </Page>
  );
}
